
export default function TriangleShape(anchorX, anchorY, rotated) {
   
  const path =  `M ${anchorX + rotated[0].x},${anchorY + rotated[0].y} L ${anchorX + rotated[1].x},${anchorY + rotated[1].y} L ${anchorX + rotated[2].x},${anchorY + rotated[2].y} Z`;

  return path;
}


